const DoubleTriangleArrow = () => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      fill="none"
      viewBox="0 0 10 16"
      data-palette="DoubleTriangleArrow">
      <path fill="#FCCB18" d="m10 8-4 4V4z" />
      <path
        fill="#FCCB18"
        stroke="var(--tooltipInfoBoxColor)"
        strokeWidth="1.4"
        d="M6.495 8.495 6.99 8l-.495-.495-4-4L1.3 2.31v11.38l1.195-1.195z"
      />
    </svg>)
  );
};

export default DoubleTriangleArrow;
